import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useMerchantAuth } from '../../../contexts/MerchantAuthContext';
import Header from '../Header';
import Footer from '../Footer';
import useRouteMeta from '../../../hooks/useRouteMeta';
import './LandingPage.css';
import FlutterServicesAPI from '../../../services/flutterServices';
import Blogs from '../Blogs';
import CaseStudy from '../CaseStudy/CaseStudy';

const LandingPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useMerchantAuth();

  const handleLoginSignup = (e) => {
    e.preventDefault();
    if (isAuthenticated()) {
      navigate('/dashboard');
    } else {
      navigate('/login');
    }
  };
  // SEO Meta Tags - Automatically applied from config
  useRouteMeta();

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [currentSlideCardIndex, setCurrentSlideCardIndex] = useState(0);
  const [currentSlideCardIndex2, setCurrentSlideCardIndex2] = useState(0);
  const [isSlideCardTransitioning, setIsSlideCardTransitioning] = useState(false);
  const [isSlideCardTransitioning2, setIsSlideCardTransitioning2] = useState(false);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

  // Array of carousel images - you can add more images here
  const carouselImages = [
    {
      src: "/assets/img/website/model_1.png",
      alt: "Glammify creative"
    },
    {
      src: "/assets/img/website/model_2.png",
      alt: "Glammify creative 2"
    },
    {
      src: "/assets/img/website/model_3.png",
      alt: "Glammify creative 3"
    },
    {
      src: "/assets/img/website/model_4.png",
      alt: "Glammify creative 3"
    },
    {
      src: "/assets/img/website/model_5.png",
      alt: "Glammify creative 3"
    }
  ];

  // Array of slide card images
  const slideCardImages = [
    {
      src: "/assets/img/website/ai_model_2.png",
      alt: "AI Model 2"
    },
    {
      src: "/assets/img/website/ai_model_1.png",
      alt: "AI Model 1"
    },
    {
      src: "/assets/img/website/ai_model_3.png",
      alt: "AI Model 3"
    }
  ];

  // Array of slide card images 2
  const slideCardImages2 = [
    {
      thumbnail_landscape: "/assets/video/vid1_model.png",
      thumbnail_portrait: "/assets/video/vid1_model.png",
      src_landscape: "/assets/video/vid1.mp4",
      src_portrait: "/assets/video/vid1_port.mp4",
      alt: "AI Model 1"
    },
    {
      thumbnail_landscape: "/assets/video/vid1_model.png",
      thumbnail_portrait: "/assets/video/vid1_model.png",
      src_landscape: "/assets/video/vid2.mp4",
      src_portrait: "/assets/video/vid2_port.mp4",
      alt: "AI Model 2"
    },
    {
      thumbnail_landscape: "/assets/video/vid1_model.png",
      thumbnail_portrait: "/assets/video/vid1_model.png",
      src_landscape: "/assets/video/vid3.mp4",
      src_portrait: "/assets/video/vid3_port.MP4",
      alt: "AI Model 3"
    }
  ];

  // const slideCardImages2 = [
  //   {
  //     src: "/assets/img/website/ai_model_1.svg",
  //     alt: "AI Model 1"
  //   },
  //   {
  //     src: "/assets/img/website/ai_model_2.svg",
  //     alt: "AI Model 2"
  //   },
  //   {
  //     src: "/assets/img/website/ai_model_1.svg",
  //     alt: "AI Model 3"
  //   },
  // ];


  // Array of testimonials
  const testimonials = [
    {
      id: 1,
      initial: "M",
      quote: "Our photoshoot costs dropped by over 70%. And we're seeing double the enquiries online.",
      author: "Narendra Jain",
      company: "Vardhaman Jwellers"
    },
    {
      id: 2,
      initial: "S",
      quote: "It used to take us 10 days to get creatives ready. Now we roll out collections in under 24 hours.",
      author: "Kamal Mehta",
      company: "Reyansh Gold"
    }
  ];

  useEffect(() => {
    if (carouselImages.length <= 1) return;

    const interval = setInterval(() => {
      setIsTransitioning(true);

      setTimeout(() => {
        setCurrentImageIndex((prevIndex) =>
          (prevIndex + 1) % carouselImages.length
        );
        setIsTransitioning(false);
      }, 500); // Half second for fade out
    }, 4000); // 4 seconds total cycle

    return () => clearInterval(interval);
  }, [carouselImages.length]);

  // Slide card carousel effect
  useEffect(() => {
    if (slideCardImages.length <= 1) return;

    const interval = setInterval(() => {
      setIsSlideCardTransitioning(true);

      setTimeout(() => {
        setCurrentSlideCardIndex((prevIndex) =>
          (prevIndex + 1) % slideCardImages.length
        );
        setIsSlideCardTransitioning(false);
      }, 500); // Half second for fade out
    }, 3000); // 3 seconds total cycle for slide cards

    return () => clearInterval(interval);
  }, [slideCardImages.length]);

  // Slide card carousel effect
  useEffect(() => {
    if (slideCardImages2.length <= 1 || isVideoPlaying) return;

    const interval = setInterval(() => {
      setIsSlideCardTransitioning2(true);

      setTimeout(() => {
        setCurrentSlideCardIndex2((prevIndex) =>
          (prevIndex + 1) % slideCardImages2.length
        );
        setIsSlideCardTransitioning2(false);
      }, 1000); // Half second for fade out
    }, 5000); // 3 seconds total cycle for slide cards

    return () => clearInterval(interval);
  }, [slideCardImages2.length, isVideoPlaying]);

  // Handle scroll to hash on load
  useEffect(() => {
    if (location.hash === '#features-section') {
      setTimeout(() => {
        const element = document.getElementById('features-section');
        if (element) {
          const headerOffset = 80;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    }
    if (location.hash === '#case-studies-section') {
      setTimeout(() => {
        const element = document.getElementById('case-studies-section');
        if (element) {
          const headerOffset = 80;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  }, [location]);

  return (
    <div className="landing-page">
      <Header />

      <section className='header-gradient position-relative'>
        <div className='container-fluid'>
          <div className='col-md-12 carousel-section'>
            <img
              src="/assets/img/website/star.svg"
              alt="Glammify Logo"
              className="sparkle-image"
            />
            <div className='row'>
              <div className='col-md-10 col-12 col-lg-7 section-content'>
                <h2>Where Jewellery Meets<br /> <span className='font-montserrat'>AI</span> Glamour</h2>
                <p>Bring your designs to life on stunning AI models <br /><span>No shoots, No studios, No waiting around</span><br />
                  Just upload, customise, and go live</p>
                <button className="btn btn-secondary" onClick={handleLoginSignup}>Login / Sign up</button>
              </div>
            </div>
          </div>
        </div>
        <div className='header-image-anim'>

          <div className={`carousel-container ${isTransitioning ? 'fade-out' : 'fade-in'}`}>
            <img
              src={carouselImages[currentImageIndex].src}
              alt={carouselImages[currentImageIndex].alt}
              className="img-fluid carousel-image"
            />
          </div>
        </div>
      </section>

      <section className='sections bg-white'>
        <div className='container-fluid'>
          <div className='row justify-content-center'>
            <div className='col-md-12 col-lg-9 col-xl-8 text-center section-headings'>
              <h2 className='font-heading'> Turn a Product Photo Into a Glam Look In Just <span className='font-montserrat'>3</span> Easy Steps</h2>
            </div>
          </div>
          <div className='row justify-content-center'>
            <div className='col-md-12 col-lg-12'>
              <div className="process-steps-container">
                <div className="row">
                  {/* Step 1: Upload */}
                  <div className="col-md-4">
                    <div className="process-step-card">
                      <div className="step-image">
                        <img src="/assets/img/website/Step-1.gif" alt="Model with Necklace" className='img-fluid' />
                      </div>
                    </div>
                    <div className="step-info text-center">
                      <span className="step-number">Step 1</span>
                      <h4>Upload</h4>
                      <p>Start by uploading a photo of your jewellery. Necklaces, rings, bangles, earrings-bring it all</p>
                    </div>
                  </div>

                  {/* Step 2: Choose Your Style */}
                  <div className="col-md-4">
                    <div className="process-step-card">
                      <div className="step-image">
                        <img src="/assets/img/website/Step-2.gif" alt="Model with Necklace" className='img-fluid' />
                      </div>
                    </div>
                    <div className="step-info text-center">
                      <span className="step-number">Step 2</span>
                      <h4>Choose Your Style</h4>
                      <p>Pick the model look you want- choose gender, ethnicity, background & media</p>
                    </div>
                  </div>

                  {/* Step 3: Get Your Creatives */}
                  <div className="col-md-4">
                    <div className="process-step-card">
                      <div className="step-image">
                        <img src="/assets/img/website/Step-3.jpg" alt="Model with Necklace" className='img-fluid' />
                      </div>
                    </div>
                    <div className="step-info text-center">
                      <span className="step-number">Step 3</span>
                      <h4>Get Your Creatives</h4>
                      <p>In just a few minutes, get studio-quality images or videos of your piece, modelled and ready to share</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="features-section" className='sections bg-linear-gradient'>
        <div className='container-fluid'>
          <div className='row justify-content-center'>
            <div className='col-md-12 text-center section-headings'>
              <h2 className='font-heading'> Why More Jewellers Are Choosing Glammify</h2>
            </div>
          </div>
          <div className='row justify-content-center'>
            <div className='col-md-12 col-lg-12 col-xxl-11'>
              <div className="info-cards-container">
                <div className="row">
                  {/* Card 1: Showcase Like a Brand Boss */}
                  <div className="col-md-6 col-lg-4 mb-4 mb-md-1 mb-lg-1 p-md-2 p-lg-4">
                    <div className="info-card">
                      <div className="card-icon">
                        <img src="/assets/img/website/card-icon-1.svg" alt="Showcase Like a Brand Boss" />
                      </div>
                      <h4 className="card-title">Showcase Like a Brand Boss</h4>
                      <p className="card-description">Display every piece on models that match your vibe</p>
                    </div>
                  </div>

                  {/* Card 2: No More Studio Runs */}
                  <div className="col-md-6 col-lg-4 mb-4 mb-md-1 mb-lg-1 p-md-2 p-lg-4">
                    <div className="info-card">
                      <div className="card-icon">
                        <img src="/assets/img/website/card-icon-2.svg" alt="No More Studio Runs" />
                      </div>
                      <h4 className="card-title">No More Studio Runs</h4>
                      <p className="card-description">Say goodbye to booking shoots, managing lights, or hiring talent</p>
                    </div>
                  </div>

                  {/* Card 3: Ready in Minutes */}
                  <div className="col-md-6 col-lg-4 mb-4 mb-md-1 mb-lg-1 p-md-2 p-lg-4">
                    <div className="info-card">
                      <div className="card-icon">
                        <img src="/assets/img/website/card-icon-3.svg" alt="Ready in Minutes" />
                      </div>
                      <h4 className="card-title">Ready in Minutes</h4>
                      <p className="card-description">Need something fast? We deliver model visuals in a flash</p>
                    </div>
                  </div>

                  {/* Card 4: Perfect Everywhere */}
                  <div className="col-md-6 col-lg-4 mb-4 mb-md-1 mb-lg-1 p-md-2 p-lg-4">
                    <div className="info-card">
                      <div className="card-icon">
                        <img src="/assets/img/website/card-icon-4.svg" alt="Perfect Everywhere" />
                      </div>
                      <h4 className="card-title">Perfect Everywhere</h4>
                      <p className="card-description">Use the content on your website, Instagram, catalogue, or store screen</p>
                    </div>
                  </div>

                  {/* Card 5: Images or Reels */}
                  <div className="col-md-6 col-lg-4 mb-4 mb-md-1 mb-lg-1 p-md-2 p-lg-4">
                    <div className="info-card">
                      <div className="card-icon">
                        <img src="/assets/img/website/card-icon-5.svg" alt="Images or Reels" />
                      </div>
                      <h4 className="card-title">Images or Reels</h4>
                      <p className="card-description">Get product shots, lifestyle looks, or model videos</p>
                    </div>
                  </div>

                  {/* Card 6: Boost Brand Presence */}
                  <div className="col-md-6 col-lg-4 mb-4 mb-md-1 mb-lg-1 p-md-2 p-lg-4">
                    <div className="info-card">
                      <div className="card-icon">
                        <img src="/assets/img/website/card-icon-6.svg" alt="Boost Brand Presence" />
                      </div>
                      <h4 className="card-title">Boost Brand Presence</h4>
                      <p className="card-description">Whether you sell on WhatsApp or Instagram or billboards, Glammify lifts your game in one click</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Case Study Section */}
      <CaseStudy id="case-studies-section" />

      <section className='sections-p-0 pb-0 bg-white position-relative'>
        <div className='container-fluid position-relative'>
          <div className='row justify-content-center'>
            <div className='col-md-10 col-lg-9 text-center section-headings mb-heading-text'>
              {/* Desktop/Tablet version */}
              <h2 className='font-heading d-none d-md-block'>See the <span className='font-montserrat'>AI</span> Magic for Yourself<br />
                Compare your simple product photos<br />
                with the Glammified versions</h2>

              {/* Mobile version */}
              <h2 className='font-heading d-block d-md-none'>See the <span className='font-montserrat'>AI</span> Magic for Yourself
                Compare your simple product photos
                with the Glammified versions</h2>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12 bg-image-1'>
              <div className='row justify-content-center'>
                <div className='col-md-12 col-lg-11 col-xxl-10 g-top-60'>
                  <div className="slide-cards-container">
                    <div className="row">
                      <div className="col-md-12 col-lg-6">
                        <div className="slide-card">
                          <div className={`slide-card-carousel ${isSlideCardTransitioning ? 'fade-out' : 'fade-in'}`}>
                            <img
                              src={slideCardImages[currentSlideCardIndex].src}
                              alt={slideCardImages[currentSlideCardIndex].alt}
                              className='img-fluid'
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12 col-lg-6 d-flex align-items-center">
                        <div className="slide-card-content">
                          <h4>Plain photo vs Jewellery styled on an AI model </h4>
                          <button className="btn btn-primary-web" onClick={handleLoginSignup}>
                            Login / Sign up
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12 bg-image-2'>
              <div className='row justify-content-center'>
                <div className='col-md-12 col-lg-12 col-xxl-11 g-top-100'>
                  <div className="slide-cards-container">
                    <div className="row">
                      <div className="col-md-12 col-lg-6 order-2 order-md-2 order-lg-1 d-flex align-items-center">
                        <div className="slide-card-content">
                          <h4>Flat lay vs high-quality
                            video with expression
                            and background </h4>
                          <button className="btn btn-primary-web" onClick={handleLoginSignup}>
                            Login / Sign up
                          </button>
                        </div>
                      </div>
                      <div className="col-md-12 col-lg-6 order-1 order-md-1 order-lg-2">
                        <div className="slide-card">
                          <div className={`slide-card-carousel ${isSlideCardTransitioning2 ? 'fade-out' : 'fade-in'}`} style={{ position: 'relative', height: '100%', width: '100%' }}>
                            {slideCardImages2[currentSlideCardIndex2].src_portrait && (slideCardImages2[currentSlideCardIndex2].src_portrait.endsWith('.mp4') || slideCardImages2[currentSlideCardIndex2].src_portrait.endsWith('.MP4')) ? (
                              <div class="video-wrapper">
                                <video
                                  src={slideCardImages2[currentSlideCardIndex2].src_portrait}
                                  // poster={slideCardImages2[currentSlideCardIndex2].thumbnail}
                                  className='img-fluid'
                                  style={{ width: '100%', height: '100%', objectFit: 'cover', cursor: 'pointer', borderRadius: '10px' }}
                                  onPlay={() => setIsVideoPlaying(true)}
                                  onPause={() => setIsVideoPlaying(false)}
                                  onEnded={() => setIsVideoPlaying(false)}
                                  onClick={(e) => {
                                    if (e.target.paused) e.target.play();
                                    else e.target.pause();
                                  }}
                                  playsInline
                                />
                                {!isVideoPlaying && (
                                  <div
                                    style={{
                                      position: 'absolute',
                                      top: '50%',
                                      left: '50%',
                                      transform: 'translate(-50%, -50%)',
                                      pointerEvents: 'none',
                                      backgroundColor: 'rgba(255, 255, 255, 0.5)',
                                      borderRadius: '50%',
                                      width: '60px',
                                      height: '60px',
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      backdropFilter: 'blur(4px)'
                                    }}
                                  >
                                    <svg style={{ marginLeft: '4px' }} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M6 4L20 12L6 20V4Z" fill="black" />
                                    </svg>
                                  </div>
                                )}
                              </div>
                            ) : (
                              <img
                                src={slideCardImages2[currentSlideCardIndex2].src}
                                alt={slideCardImages2[currentSlideCardIndex2].alt}
                                className='img-fluid'
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12 g-top-100'>
              <div className='row justify-content-center'>
                <div className='col-md-12 col-lg-12 text-md-center text-lg-center text-center section-headings'>
                  <h2 className='font-heading mb-p-5'><span style={{ color: 'var(--text-black)' }}>What Jewellers Are Saying About</span> Glammify.</h2>
                </div>
                <div className="col-md-12 col-lg-11 col-xxl-11">
                  <div className="testimonial-slider-container">
                    {/* Carousel */}
                    <div id="demo" className="carousel slide" data-bs-ride="carousel">

                      {/* The slideshow/carousel */}
                      <div className="carousel-inner">
                        {testimonials.map((testimonial, index) => (
                          <div
                            key={testimonial.id}
                            className={`carousel-item ${index === 0 ? 'active' : ''}`}
                          >
                            <div className='row'>
                              <div className='col-md-12 col-lg-3 d-flex align-items-center justify-content-center'>
                                <div className='testimonial-card'>
                                  <img src="/assets/img/website/testimo-img.svg" alt={`${testimonial.author} Avatar`} className="img-fluid" />
                                </div>
                              </div>
                              <div className='col-md-12 col-lg-9'>
                                <div className='testimonial-card-content'>
                                  <p>{testimonial.quote}</p>
                                  <h3 className='person-name'>{testimonial.author}</h3>
                                  <h4 className='person-company'>{testimonial.company}</h4>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>

                      {/* Left and right controls/icons */}
                      <button className="carousel-control-prev" type="button" data-bs-target="#demo" data-bs-slide="prev">
                        <img src="/assets/img/website/left-ico.svg" alt="Left Arrow" className="img-fluid" />
                      </button>
                      <button className="carousel-control-next" type="button" data-bs-target="#demo" data-bs-slide="next">
                        <img src="/assets/img/website/right-ico.svg" alt="Right Arrow" className="img-fluid" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* Blogs Section */}
      {/* <Blogs maxItems={3} showViewAll={true} /> */}


      <section className='pricing-section-new'>
        <div className='container seciton-pricing'>
          <div className='row justify-content-center'>
            <div className='col-md-12 col-lg-12 col-xxl-12 col-12'>
              <div className='row justify-content-center'>
                <div className='col-md-12 pb-0 text-center section-headings d-flex justify-content-center align-items-center'>
                  <h2 className='font-heading section-3'>Simple, Flexible Pricing - <br />Pay Only for What You Create</h2>
                </div>
              </div>
            </div>
          </div>
          <div className='row'>
            {/* Left Column */}
            <div className='col-lg-7 col-md-7'>
              <h3 className='how-it-works-title'>How it works</h3>

              <div className='how-it-works-card'>
                <div className='how-it-works-card-icon'>
                  <img src="/assets/img/website/buy_credit.svg" alt={`Buy ${FlutterServicesAPI.getCreditLabel()}`} className="img-fluid" />
                </div>
                <div className='how-it-works-card-content'>
                  <h5>{`Buy ${FlutterServicesAPI.getCreditLabel()}`}</h5>
                  <p>{`Buy ${FlutterServicesAPI.getCreditLabel().toLowerCase()} and use them anytime — no pressure of fixed monthly limits`}</p>
                </div>
              </div>

              <div className='how-it-works-card'>
                <div className='how-it-works-card-icon'>
                  <img src="/assets/img/website/choose_model_type.svg" alt="Choose Model Type" className="img-fluid" />
                </div>
                <div className='how-it-works-card-content'>
                  <h5>Choose Model Type</h5>
                  <p>Choose between Bust Models or Full Human Models for your visuals</p>
                </div>
              </div>

              <div className='how-it-works-card'>
                <div className='how-it-works-card-icon'>
                  <img src="/assets/img/website/pick_output_quality.svg" alt="Pick Output Quality" className="img-fluid" />
                </div>
                <div className='how-it-works-card-content'>
                  <h5>Pick Output Quality</h5>
                  <p>Select output quality: 1K, 2K, 4K, or Premium Campaign Quality</p>
                </div>
              </div>

              <div className='how-it-works-card'>
                <div className='how-it-works-card-icon'>
                  <img src="/assets/img/website/save_more_scale.svg" alt="Save More at Scale" className="img-fluid" />
                </div>
                <div className='how-it-works-card-content'>
                  <h5>Save More at Scale</h5>
                  <p>{`Higher ${FlutterServicesAPI.getCreditLabel().toLowerCase()} packages reduce the cost per image`}</p>
                </div>
              </div>

              <div className='how-it-works-card'>
                <div className='how-it-works-card-icon'>
                  <img src="/assets/img/website/unlock_addons.svg" alt="Unlock Add-ons" className="img-fluid" />
                </div>
                <div className='how-it-works-card-content'>
                  <h5>Unlock Add-ons</h5>
                  <p>Add-ons become available based on your selected package</p>
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div className='col-lg-5 col-md-5'>
              <div className='pro-card-container'>
                <div className='pro-card-border-wrap'>
                  <div className='pro-card-inner'>
                    <div className='pro-card-content-z'>
                      <div className='unlock-more-badge'>UNLOCK MORE</div>
                      <h4 className='pro-card-title'>Powerful Add-ons<br />for Pro Campaigns</h4>

                      <div className='pro-list-item'>
                        <div className='pro-list-icon'>
                          <img src="/assets/img/website/save_your_model.svg" alt="Use your own model" className="img-fluid" />
                        </div>
                        <p className='pro-list-text'>Use your own model or customer photo</p>
                      </div>

                      <div className='pro-list-item'>
                        <div className='pro-list-icon'>
                          <img src="/assets/img/website/generate_instagram.svg" alt="Generate Instagram Reels" className="img-fluid" />
                        </div>
                        <p className='pro-list-text'>Generate Instagram Reels & marketing videos</p>
                      </div>

                      <div className='pro-list-item'>
                        <div className='pro-list-icon'>
                          <img src="/assets/img/website/advanced_creative.svg" alt="Advanced creative tools" className="img-fluid" />
                        </div>
                        <p className='pro-list-text'>Advanced creative tools for campaigns</p>
                      </div>

                      <div className='pro-bottom-box'>
                        <p className='pro-bottom-text'>
                          Create studio-quality jewellery campaigns at a fraction of traditional <span>Photoshoot Costs.</span>
                        </p>
                        <button className='btn-explore-pricing' onClick={() => navigate("/pricing")}>
                          Explore Pricing & Packages
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* <section className='sections-p-0 pb-0 bg-white position-relative'>
        <div className='container-fluid position-relative placeholder-section'>
          {!FlutterServicesAPI.isFlutterApp() && (
            <div className='row'>
              <div className='col-md-12 placeholder-overlap'>
                <div className='row justify-content-center'>
                  <div className='col-md-12 col-lg-12 text-md-center text-lg-center text-center section-headings'>
                    <h2 className='font-heading'>Simple & Transparent Pricing - No Surprises</h2>
                  </div>
                  <div className="col-md-12 col-lg-11 col-xxl-9">
                    <div className="section-container">
                      <div className='row'>
                        <div className='col-md-12 col-lg-8'>
                          <ul className='list-unstyled section-list-items'>
                            <li><img src="/assets/img/website/check.svg" alt="Check" className='img-fluid' /> Free trial {FlutterServicesAPI.getCreditLabel().toLowerCase()} so you can test drive the platform risk-free</li>
                            <li><img src="/assets/img/website/check.svg" alt="Check" className='img-fluid' /> Know exactly what each creative costs before you generate</li>
                            <li><img src="/assets/img/website/check.svg" alt="Check" className='img-fluid' /> Top up as you go, with bigger savings on bulk buys</li>
                            <li><img src="/assets/img/website/check.svg" alt="Check" className='img-fluid' /> Custom plans for startups, boutiques, and large brands</li>
                          </ul>
                        </div>
                        <div className='col-md-12 col-lg-4 d-flex align-items-center justify-content-center'>
                          <div className='section-card'>
                            <Link className='btn btn-primary-web font-large' to="/pricing">View Pricing Plans</Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </section> */}
      <Footer />
    </div>
  );
};

export default LandingPage;
